import KosmoButton from "@/UI/Buttons/KosmoButton"
import DragAndUploadFileModule, {
  KMLFormatFile,
  KMZFormatFile,
} from "@/UI/Inputs/DragAndUploadFileModule"
import { Modal, Button, UploadFile, message } from "antd"
import { useTranslation } from "react-i18next"
import { useState } from "react"
import { useZones } from "@/hooks/useZones"
import { isPayingUserSelector } from "@/atoms/userAtom"
import { PROFILE_PAGE_PATH } from "@/constants/routes"
import { useSandboxRouter } from "@/hooks/useSandboxRouter"
import PreventWithModal from "@/UI/PreventWithModal"
import { useRecoilValue } from "recoil"
import React from "react"

type ImportZoneModalProps = {
  isDisabled: boolean
}

const ImportZoneModal: React.FC<ImportZoneModalProps> = ({ isDisabled }) => {
  const { t } = useTranslation()
  const { sandboxRouter } = useSandboxRouter()
  const isPayingUser = useRecoilValue(isPayingUserSelector)
  const [file, setFile] = useState<UploadFile[]>([])
  const [open, setOpen] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { zones, importZones } = useZones()

  const onClose = () => {
    setFile([])
    setOpen(false)
  }

  const handleNext = () => {
    if (
      file === undefined ||
      file.length === 0 ||
      file[0] === undefined ||
      file[0].originFileObj === undefined
    ) {
      return
    }
    setIsLoading(true)
    importZones(file[0].originFileObj)
      .then(() => {
        onClose()
      })
      .catch((error) => {
        console.log(error)
        message.error(error.message)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  if (!isPayingUser) {
  }

  return (
    <>
      <Modal
        open={open}
        title={t("common.importFile")}
        onCancel={onClose}
        footer={[
          <div className="flex flex-col">
            <div className="flex justify-end ">
              <Button className="" onClick={onClose}>
                {t("common.cancel")}
              </Button>
              <KosmoButton
                id="draft-order-upload-next-step"
                classname="ml-2"
                isDisabled={isDisabled || !file.length}
                isLoading={isLoading}
                onClick={handleNext}
                type="primary"
              >
                {t("zones.ImportZonesModal.upload")}
              </KosmoButton>
            </div>
          </div>,
        ]}
      >
        <div className={`flex flex-col w-full space-y-4 items-center`}>
          <DragAndUploadFileModule
            file={file}
            setFile={(file) => {
              setFile(file)
            }}
            isDisabled={false}
            supportedFileTypes={[KMLFormatFile, KMZFormatFile]}
            toShowZonesWarning={zones.length > 0}
            hint={t("zones.ImportZonesModal.uploadMaxSize")}
          />
        </div>
      </Modal>
      <PreventWithModal
        enable={!isPayingUser}
        label={t("onboarding.freePlanBannerDescription")}
        cta={{
          label: t("profile.planCard.startNow"),
          onClick: () => sandboxRouter.push(`${PROFILE_PAGE_PATH}/?p=plans`),
        }}
      >
        <Button type="primary" onClick={() => setOpen(true)}>
          {t("common.zones.import")}
        </Button>
      </PreventWithModal>
    </>
  )
}

export default ImportZoneModal
